import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_collect_hl",
  "use": "icon-ic_collect_hl-usage",
  "viewBox": "0 0 34 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 33\" id=\"icon-ic_collect_hl\"><g fill=\"none\"><path d=\"M1 0h32v32H1z\" /><path d=\"M9.657 31.852a3 3 0 0 1-4.353-3.163l1.359-7.923-5.757-5.611a3 3 0 0 1 1.663-5.117l7.955-1.156 3.558-7.21a3 3 0 0 1 5.38 0l3.558 7.21 7.956 1.156a3 3 0 0 1 1.662 5.117l-5.756 5.611 1.359 7.923a3 3 0 0 1-4.353 3.163l-7.116-3.74-7.115 3.74z\" fill=\"#777\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol